<template>
  <div class="modal fade" id="ControllerNameEditModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content" v-if="controller">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">{{ controller.name }}</h5>
          <button type="button" class="btn-close" id="close-controller-modal" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <form class="popup-form" @submit.prevent="updateController">
          <div class="modal-body">
            <div class="mb-3">
              <label for="room-name" class="form-label">კონტროლერის სახელი</label>
              <input type="text" required minlength="1" maxlength="255" class="form-control" id="room-name" name="name" v-model="name">
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary">შენახვა</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ControllerNameEditModal',
  data() {
    return {
      name: '',
    };
  },
  computed: {
    controller() {
      return this.$parent.selectedController;
    },
  },
  watch: {
    controller: {
      handler(newVal) {
        if (newVal) this.name = newVal.name;
      },
      immediate: true,
    },
  },
  methods: {
    updateController() {
      this.$store.dispatch('warehouse/updateWarehouse', {
        warehouse_id: this.controller.warehouse_id,
        name: this.name,
      }).then(() => {
        if (this.name) {
          this.controller.name = this.name;
          document.getElementById('close-controller-modal').click();
        }
      });
    },
  },
};
</script>
